import { LOCALE_US_EN } from 'models/location/constants'

export const isEmpty = (obj) => Object.keys(obj).length === 0 && obj.constructor === Object

export const getShoppingCartUrl = (region = LOCALE_US_EN) => `https://www.ikea.com/${region}/shoppingcart/`

// Return a url for checkout of ikea products
// items: array of string (global product id's) or null
export const getAddToCartUrl = (items, region = LOCALE_US_EN) => {
    if (!items || !items.length) {
        return null
    }

    const IKEA_SHOPPING_CART_URL = getShoppingCartUrl(region)

    // Create a hash of global product id's so that we can create a url of the type:
    // `...items?<global_product_id1>:<num_ordered>&<global_product_id2>:<num_ordered>...`
    const itemsCount = items.reduce((acc, curr) => {
        // skip if curr value is null or empty string
        // ie., this product does not have a global product id
        if (!curr) {
            return acc
        }

        if (acc[curr]) {
            acc[curr] += 1
        } else {
            acc[curr] = 1
        }
        return acc
    }, {})

    if (isEmpty(itemsCount)) {
        return null
    }

    const resultUrl = Object.keys(itemsCount).reduce(
        (acc, curr) => `${acc}${curr}:${itemsCount[curr]},`,
        `${IKEA_SHOPPING_CART_URL}?items=`,
    )

    // Remove the trailing '&'
    return resultUrl.slice(0, resultUrl.length - 1)
}
